import React from "react";
import { Lock, Unlock, CalendarOff } from "lucide-react";

// Day-level closure banner + quick buttons (blocks ONLINE bookings only; staff can always book by hand).
export function ClosureBanner({ day, monthInfo, onClosure, compact = false }) {
  if (!monthInfo) return null;
  const svc = monthInfo.services || {};
  const keys = Object.keys(svc);
  const cl = monthInfo.closures?.[day] || [];
  const wd = (new Date(day + "T12:00:00").getDay() + 6) % 7;
  const fixedClosed = (monthInfo.closed_weekdays || []).includes(wd) || (monthInfo.closed_dates || []).includes(day);
  const allClosed = fixedClosed || (keys.length > 0 && keys.every((k) => cl.includes(k)));
  const label = allClosed ? "Giornata chiusa" : cl.length ? `Chiuso · ${cl.map((k) => svc[k] || k).join(" + ")}` : "";
  const dd = day.split("-").reverse().slice(0, 2).join("/");

  if (!label) {
    return (
      <div className={`flex flex-wrap items-center gap-1.5 ${compact ? "text-[11px]" : "text-xs"}`} data-testid="closure-controls">
        <span className="inline-flex items-center gap-1 text-[#7c5a4e]"><CalendarOff className="h-3.5 w-3.5" /> Online {dd}:</span>
        {keys.map((k) => <button key={k} onClick={() => onClosure(day, [k])} className="rounded-full border border-rose-200 bg-white text-rose-800 px-2.5 py-1 font-semibold hover:bg-rose-50" data-testid={`closure-btn-${k}`}>Chiudi {svc[k]}</button>)}
        <button onClick={() => onClosure(day, keys)} className="rounded-full bg-rose-600 text-white px-2.5 py-1 font-semibold" data-testid="closure-btn-all"><Lock className="h-3 w-3 inline -mt-0.5" /> Chiudi giornata</button>
      </div>
    );
  }
  return (
    <div className="rounded-2xl bg-rose-600 text-white px-3 py-2 flex flex-wrap items-center gap-2 text-sm" data-testid="closure-banner">
      <Lock className="h-4 w-4" /><b>{label}</b><span className="text-white/80 text-xs">· prenotazioni online bloccate, tu puoi inserire a mano</span>
      <div className="flex-1" />
      {!allClosed && keys.filter((k) => !cl.includes(k)).map((k) => <button key={k} onClick={() => onClosure(day, keys)} className="rounded-full bg-white/15 px-2.5 py-1 text-xs font-bold" data-testid={`closure-extend-${k}`}>Chiudi anche {svc[k]}</button>)}
      {!fixedClosed && <button onClick={() => onClosure(day, [])} className="rounded-full bg-white text-rose-700 px-3 py-1 text-xs font-bold inline-flex items-center gap-1" data-testid="closure-reopen-btn"><Unlock className="h-3 w-3" /> Riapri</button>}
      {fixedClosed && <span className="text-xs text-white/80">(chiusura fissa: cambia dalle Impostazioni)</span>}
    </div>
  );
}
